import axios from 'axios';

import {
  ABSENCES,
  CLIENT_ABSENCES,
  DELETE_CLIENT_ABSENCE_PERIOD,
  END_CLIENT_ABSENCE_PERIOD,
  GET_CLIENT_ABSENCE_REASONS,
  UPDATE_CLIENT_ABSENCE
} from '../endpoints';

type DeleteAbsenceOptions = {
  absenceId: number;
  startDate: string | null;
  endDate: string | null;
};

export const deleteAbsence = ({
  absenceId,
  startDate,
  endDate
}: DeleteAbsenceOptions) =>
  axios.delete(`${ABSENCES}/${absenceId}`, {
    params: {
      start: startDate ?? null,
      end: endDate ?? null
    }
  });

export type AppointmentIdentifier = { id: string; originalId: string | null };

export type ClientAbsence = {
  absentAppointments: AppointmentIdentifier[];
  clientAbsenceId: string;
  clientId: string;
  start: string;
  end: string;
  reasonId: string;
  description?: string;
};

export type GetClientAbsencesOptions = {
  clientId: string;
  startDate?: Date;
  endDate?: Date;
};

export const getClientAbsences = ({
  clientId,
  startDate,
  endDate
}: GetClientAbsencesOptions) =>
  axios.get<ClientAbsence[]>(CLIENT_ABSENCES, {
    params: {
      startDate,
      endDate
    },
    pathParams: {
      clientId
    }
  });

type ClientAbsenceReason = {
  id: string;
  name: string;
};

type CreateClientAbsenceRequest = {
  reasonId: string;
  description?: string;
  start: Date;
  end?: Date | null;
  absentAppointments: AppointmentIdentifier[] | null;
};

export type CreateClientAbsenceOptions = CreateClientAbsenceRequest & {
  clientId: string;
};

export const getClientAbsenceReasons = () =>
  axios.get<ClientAbsenceReason[]>(GET_CLIENT_ABSENCE_REASONS);

export const createClientAbsenceRequest = ({
  clientId,
  ...params
}: CreateClientAbsenceOptions) => {
  axios.post(CLIENT_ABSENCES, params, {
    pathParams: {
      clientId
    }
  });
};

export type UpdateClientAbsenceOptions = {
  clientId: string;
  clientAbsenceId: string;
} & CreateClientAbsenceRequest;

export const updateClientAbsence = ({
  clientId,
  clientAbsenceId,
  ...params
}: UpdateClientAbsenceOptions) => {
  axios.put(UPDATE_CLIENT_ABSENCE, params, {
    pathParams: { clientId, clientAbsenceId }
  });
};

export type EndClientAbsencePeriodOptions = {
  clientId: string;
  clientAbsenceId: string;
  end: string;
};

export const endClientAbsencePeriod = ({
  clientId,
  clientAbsenceId,
  end
}: EndClientAbsencePeriodOptions) => {
  axios.put(
    END_CLIENT_ABSENCE_PERIOD,
    { end },
    {
      pathParams: { clientId, clientAbsenceId }
    }
  );
};

export type DeleteClientAbsencePeriodOptions = {
  clientId: string;
  clientAbsenceId: string;
};

export const deleteClientAbsencePeriod = ({
  clientId,
  clientAbsenceId
}: DeleteClientAbsencePeriodOptions) => {
  axios.delete(DELETE_CLIENT_ABSENCE_PERIOD, {
    pathParams: { clientId, clientAbsenceId }
  });
};
